import React from "react";
import Modal from "../Modal";
import { APP_NAME, APP_VERSION, ASSETS, CREDITS, LINKS } from "../../../lib/constants";

function InfoModal({ isOpen, onClose }) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="About"
        >
            <div className="space-y-6">
                {/* Hero section with CLASH logo */}
                <div className="text-center space-y-4">
                    <div className="flex justify-center">
                        <img
                            src={ASSETS.clashLogo}
                            alt="CLASH"
                            className="h-20 w-auto object-contain"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>
                    <div>
                        <h2 className="text-2xl font-extrabold text-slate-800">{APP_NAME}</h2>
                        <p className="text-sm text-slate-500 mt-1 font-medium">Version {APP_VERSION}</p>
                    </div>
                </div>

                {/* Description */}
                <p className="text-base text-slate-600 text-center leading-relaxed">
                    A word puzzle game inspired by the classic Connections format,
                    brought to you by the Roslyn OCC.
                </p>

                {/* OCC Games Branding */}
                <div className="flex flex-col items-center gap-4 py-5 border-t border-b border-slate-100">
                    <p className="text-xs text-slate-400 uppercase tracking-widest font-semibold">
                        Presented by
                    </p>
                    <img
                        src={ASSETS.occGamesLogo}
                        alt="Roslyn OCC Games"
                        className="h-14 w-auto object-contain"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                        }}
                    />
                    <span className="font-bold text-slate-800 text-lg" style={{ display: 'none' }}>
                        Roslyn OCC Games
                    </span>
                </div>

                {/* Credits */}
                <div className="space-y-3">
                    <h3 className="text-sm font-bold uppercase tracking-wide text-slate-400 text-center">
                        Credits
                    </h3>
                    <div className="text-center">
                        <p className="font-semibold text-slate-600">Developed by</p>
                        <p className="mt-1 text-slate-800 font-bold">
                            {CREDITS.developers.join(" & ")}
                        </p>
                    </div>
                </div>

                {/* Links */}
                <div className="flex justify-center gap-6 pt-2">
                    <a
                        href={LINKS.occ}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-semibold text-slate-500 hover:text-[#38B6FF] transition-colors"
                    >
                        Visit OCC
                    </a>
                    <a
                        href={LINKS.privacy}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-semibold text-slate-500 hover:text-[#38B6FF] transition-colors"
                    >
                        Privacy Policy
                    </a>
                </div>

                {/* Copyright */}
                <p className="text-xs text-center text-slate-400 font-medium">
                    © {CREDITS.year} {CREDITS.organization}. All rights reserved.
                </p>
            </div>
        </Modal>
    );
}

export default InfoModal;
